import React, { useEffect, useState } from "react"
import api from "../../services/api"
import { toast } from "react-toastify"
import ConfigTextListItems from "../../components/ConfigTextListItems"
import Loading from "../layouts/Loading"

const OriginsSettings = ({ account_id }) => {
    const [origins, setOrigins] = useState([])
    const [originsEditable, setOriginsEditable] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (account_id) {
            getAllOrigins()
        }
    }, [account_id])

    const getAllOrigins = () => {
        setLoading(true)
        api.get("/origins").then(response => {
            const listOrigins = response?.data?.data || []
            setOrigins(listOrigins)
        }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
    }

    const handleUpdateOrigins = (e, _, nextOrigins) => {
        e.preventDefault()
        setLoading(true)
        const customOrigins = nextOrigins.filter(origin => !origin.required)
        api.patch("/origins", { origins: customOrigins }).then(response => {
            const newOrigins = response?.data?.data
            if (newOrigins) {
                setOrigins(previousValue => [
                    ...previousValue.filter(origin => origin.required),
                    ...newOrigins,
                ].sort((left, right) => left.name.localeCompare(right.name, "pt-BR")))
            }
            handleToogleEditOrigins(e)
            toast.success(response?.data?.message)
        }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
    }

    const handleToogleEditOrigins = (e) => {
        e.preventDefault()
        setOriginsEditable(previousValue => !previousValue)
    }

    return (
        <>
            <ConfigTextListItems
                title="Origens"
                placeholder="Origem"
                textNotItems="Nenhuma origem cadastrada até o momento!"
                value={origins}
                onSubmit={handleUpdateOrigins}
                onCancel={handleToogleEditOrigins}
                editable={originsEditable}
                isItemReadOnly={(origin) => Boolean(origin.required)}
                getItemIndicator={(origin) => origin.required ? "Padrão do sistema" : ""}
                setEdit={handleToogleEditOrigins}
            />
            {loading && <Loading fullPage={true} />}
        </>
    )
}

export default OriginsSettings
